import { ObservableArray, View } from "binder"
import { DataModelClass } from "src/formBuilder/datamodel/structure";
import { TemplateCreatorViewModel } from "./templateCreator-viewModel"

export class TemplateCreatorView extends View<TemplateCreatorViewModel>{
    GetViewUniqueId(): string {
        return "V-3A22814D-266B-4B1C-A098-E7DE78166F45"
    }
    loadHtml(): string {
        let element = require('./templateCreator.html').default;
        let style = require('./templateCreator.less');
        return element;
    }
    constructor() {
       super();
    }

    public set newName(v: string) { this._newName = v; } public get newName(): string { return this._newName;} private _newName: string;
    public set classes(v: ObservableArray<DataModelClass>) { this._classes = v; } public get classes(): ObservableArray<DataModelClass> { return this._classes;} private _classes: ObservableArray<DataModelClass>;
    public set selectedClass(v: DataModelClass) { this._selectedClass = v; } public get selectedClass(): DataModelClass { return this._selectedClass;} private _selectedClass: DataModelClass;
    create(){
        this.dataContext.create();
    }
    back(){
        this.dataContext.back();
    }
}
